export enum AppInsightsTypes {
  SESSION_ID = 'sessionId',
  USER_ID = 'userId',
}
